import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
// Type-only, so it is erased: a value import would pull the page out of its
// lazy chunk and into the main bundle.
import type { AccessKeysComponent } from './access-keys.component';

export const appRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'organizations' },
  {
    path: 'login',
    loadComponent: () =>
      import('./login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'organizations',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./organizations.component').then((m) => m.OrganizationsComponent)
  },
  {
    // Declared before `organizations/:organizationId`, which would otherwise
    // match first and try to load an org whose id is the literal "new".
    path: 'organizations/new',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./create-organization.component').then(
        (m) => m.CreateOrganizationComponent
      )
  },
  {
    // `organizationId` is bound straight to the component input by
    // withComponentInputBinding(), so the resource re-fetches on navigation
    // between orgs without the component watching the route itself.
    path: 'organizations/:organizationId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./organization-detail.component').then(
        (m) => m.OrganizationDetailComponent
      )
  },
  {
    path: 'organizations/:organizationId/merge-users',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./organization-merge-users.component').then(
        (m) => m.OrganizationMergeUsersComponent
      )
  },
  {
    path: 'flags',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./flags.component').then((m) => m.FlagsComponent)
  },
  {
    // Cross-tenant on purpose: the keys that most need attention are the ones
    // migrated from the old hardcoded list, which belong to no organization
    // yet and would be invisible on an org-scoped screen.
    path: 'access-keys',
    canActivate: [authGuard],
    // A freshly issued key is shown once; leaving before it is copied loses
    // it, so the page asks first.
    canDeactivate: [
      (component: AccessKeysComponent) => component.confirmLeave()
    ],
    loadComponent: () =>
      import('./access-keys.component').then((m) => m.AccessKeysComponent)
  },
  {
    // `?organizationId=` is bound straight to the component input by
    // withComponentInputBinding(), so org detail can deep-link into the feed
    // already filtered to that customer.
    path: 'audit',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./audit.component').then((m) => m.AuditComponent)
  },
  {
    // Platform-wide, not per org: the crons run for every customer at once.
    path: 'cron-jobs',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./cron-jobs.component').then((m) => m.CronJobsComponent)
  },
  { path: '**', redirectTo: 'organizations' }
];
